import { GoodgameTextFieldManager } from './../../../../textfield/manager/GoodgameTextFieldManager';
import Sprite = createjs.Sprite;
import Event = createjs.Event;
import MouseEvent = createjs.MouseEvent;
import Container = createjs.Container;
import { TextField } from "@goodgamestudios/createjs-utilities";


export class AnimatedSpeechTextField extends Container {
    private textField: TextField;
    private fullText: string;
    private startTime: number;
    private delayBetweenCharacters: number;
    private updateCallback: Function;
    private _isRunning: boolean = false;
    private lastCharacterIndex: number = 0;
    private currentSkippedCharacters: number = 0;

    /**
     * SpeechTextField
     * Its a Sprite, containing a textfield, which gets filled with text after some time.
     * It's like someone is speaking with you.
     * The TextField is on 0,0 and will be expanded to the right/bottom
     * If you click on the textfield, the animation gets skipped
     *
     * TODO: Could be renamed to TypewriterEffectTextField
     * */
    constructor(textfield: TextField, text: string, delayBetweenCharacters: number, updateCallback:Function = null) {
        super();

        this.fullText = text;
        this.textField = textfield;
        this.delayBetweenCharacters = delayBetweenCharacters;
        this.mouseChildren = false;
        this.updateCallback = updateCallback;

        // create the TextField
        this.prepareTextField();

    }

    // grab the Textfield from the RanchTextFieldAsset to get the right style
    private prepareTextField(): void {
        GoodgameTextFieldManager.getInstance().setText(this.textField, this.fullText, false);
        this.addChild(this.textField);
        this.stop();
    }

    // start filling the text
    public start(): void {
        this._isRunning = true;
        this.startTime = Date.now();
        this.addEventListener(Event.ENTER_FRAME, this.bindFunction(this.onEnterFrame));
        this.addEventListener(MouseEvent.CLICK, this.bindFunction(this.skip));
        this.currentSkippedCharacters = 0;
    }

    // skip the text
    public skip(event: MouseEvent = null): void {
        this.stop();

        this.fillText(this.fullText.length);
    };

    // stop filling the text
    public stop(): void {
        this._isRunning = false;
        this.removeEventListener(Event.ENTER_FRAME, this.bindFunction(this.onEnterFrame));
        this.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.skip));
        this.currentSkippedCharacters = 0;
    }

    public onEnterFrame(e: Event): void {
        let deltaTime: number = Date.now() - this.startTime;
        let currentCharacterIndex: number = (deltaTime / this.delayBetweenCharacters) + this.currentSkippedCharacters;

        if( currentCharacterIndex !== this.lastCharacterIndex ) {
            this.fillText(currentCharacterIndex);

            if (currentCharacterIndex >= this.fullText.length) {
                this.stop();
            }
        }

        this.lastCharacterIndex = currentCharacterIndex;
    }

    // fill in the text
    private fillText(currentPosition: number): void {
        // fill in the current part of the text
        let subString: string = this.fullText.substr(0, currentPosition);

        // catch " ' html formatting
        let currentPart: string = subString.substr( currentPosition - 5 );
        let andPos: number = currentPart.lastIndexOf("&");
        let semicolonPos: number = currentPart.lastIndexOf(";");
        if ( andPos > semicolonPos ) {
            // check if ; is coming in the next few characters
            let nextPart: string = this.fullText.substr( currentPosition, 5 );
            let nextSemicolonPos: number = nextPart.indexOf(";");
            if ( nextSemicolonPos >= 0 ) {
                currentPosition += nextSemicolonPos + 1;
                this.currentSkippedCharacters += nextSemicolonPos + 1;
            }
        }

        // if it's not finished, fill up the next word with spaces to prevent weird linebreaks
        let nextWordLength: number = this.getLengthOfNextWord(currentPosition);

        for (let i: number = 0; i < nextWordLength; i++) {
            subString += " ";
        }

        GoodgameTextFieldManager.getInstance().setText(this.textField, subString, false);

        if ( this.updateCallback !== null && this.updateCallback !== undefined ) {
            this.updateCallback();
        }
    }

    private getLengthOfNextWord(currentPosition: number): number {
        let subString: string = this.fullText.substr(currentPosition);
        return subString.indexOf(" ", 1);
    }

    public isRunning():boolean {
        return this._isRunning;
    }

    public destroy(): void {
        this.stop();
        this.updateCallback = null;
        this.textField = null;
    }

}

